/* ───────────────────────────────────────────────────────────────
   RUPTURES EN FIN DE COLLECTION — SOLEIL D'OR
   v1.4 — 20/09/2026

   CE QUE SHOPIFY SAIT FAIRE, ET CE QU'IL NE SAIT PAS
   Une collection se trie par ordre manuel, meilleures ventes,
   titre, prix ou date. Aucun tri par disponibilité n'existe. Le
   paramètre unavailable_products=last ne vaut que pour la
   recherche, et une collection automatique ne peut même pas
   passer en tri manuel. Il n'y a donc rien à cocher côté admin.

   CE QUE FAISAIT DÉJÀ LE THÈME
   main-collection-product-grid.liquid parcourt les produits deux
   fois : les disponibles, puis les ruptures. Ce tri ne vaut qu'à
   l'intérieur d'une page. Comme « Voir plus » ajoute la page
   suivante à la suite, le motif recommence et les ruptures se
   répartissent dans toute la grille.

   CE QUE FAIT CE SCRIPT
   La grille est une liste unique qui s'allonge. Le script y tient
   trois groupes :
     — les cartes affichées, toujours disponibles, en nombre égal
       à ce que le visiteur a demandé (une page, puis deux…) ;
     — les cartes disponibles en trop, chargées d'avance et mises
       en attente pour le prochain « Voir plus » ;
     — les ruptures, mises de côté et révélées toutes ensemble à
       la toute fin, quand il n'y a plus rien d'autre à montrer.
   Quand il manque des cartes disponibles pour remplir la page, le
   script demande une page de plus en silence, dans la limite de
   MAX_AUTO chargements par clic du visiteur.

   DEUX POINTS DE VIGILANCE, TRAITÉS ICI
   1. L'URL ne doit pas bouger. Le bouton du thème pousse un
      history.pushState vers ?page=2 ; un chargement déclenché par
      ce script passe donc par renderPage(params, null, false),
      dont le troisième argument désactive cette écriture.
   2. Une arrivée directe sur ?page=3 doit afficher trois pages, pas
      une : l'objectif de départ est donc multiplié par le numéro de
      page lu dans l'URL.
   3. Deux chargements automatiques pouvaient partir avant que le
      premier ne soit revenu : mesuré une fois sur /collections/parfums,
      trois pages demandées au lieu de deux. Le drapeau enCours ne
      retombe que lorsque la grille s'est réellement allongée, ou au
      bout de DELAI_SECOURS si la requête a échoué.
   4. pagination.js est chargé par la section, donc APRÈS ce fichier.
      À froid, <pagination-loader> n'est pas encore un élément
      personnalisé quand on démarre : renderPage n'existe pas, la
      demande de page part dans le vide et le créneau est consommé
      pour rien — mesuré une fois, 20 produits affichés au lieu de
      24, aucune requête émise. loaderPret() vérifie donc que
      l'élément est prêt AVANT de consommer un créneau, et réessaie
      sinon.
   5. Le bouton du thème se masque dès la dernière page atteinte,
      alors qu'il reste des cartes en attente. majBouton() le
      garde visible tant qu'il reste quelque chose à révéler, et
      le clic est intercepté quand il n'y a plus de page à aller
      chercher — sinon le thème irait chercher « ?undefined ».

   LES CARTES NE SONT PAS RETIRÉES DU DOM
   Elles sont masquées en CSS, pas supprimées : leurs liens restent
   dans la page, donc explorables. Le maillage interne des fiches
   en rupture est préservé.

   CE QUI RESTE VRAI APRÈS CE SCRIPT
   Sur une collection de 750 produits, « à la fin » veut dire après
   la dernière page : un visiteur qui ne pagine pas jusqu'au bout
   ne verra pas les ruptures dans cette collection. Elles restent
   accessibles par la recherche, par la maison et par leur fiche.
   ─────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var CONTENEUR = 'product-grid-container';
  var GRILLE = 'ul#data-pagination';
  var CARTE = '.data-pagination__item';
  var RUPTURE = '.data-pagination__item[data-available="false"]';
  var DIFFEREE = 'sdo-rupture-differee';
  var ATTENTE = 'sdo-carte-en-attente';
  var MAX_AUTO = 4;
  var DELAI_SECOURS = 6000;

  var etat = null;
  var observateur = null;

  function style() {
    if (document.getElementById('sdo-rupture-style')) return;
    var s = document.createElement('style');
    s.id = 'sdo-rupture-style';
    s.textContent = '.' + DIFFEREE + ',.' + ATTENTE + '{display:none !important;}';
    (document.head || document.documentElement).appendChild(s);
  }

  function loader() { return document.querySelector('pagination-loader'); }

  /* <pagination-loader> existe dans le HTML avant d'être « upgradé » par
     pagination.js : tant que renderPage n'est pas là, rien à demander. */
  function loaderPret() {
    var l = loader();
    return !!(l && typeof l.renderPage === 'function');
  }
  function bouton() { var l = loader(); return l ? l.querySelector('.js-load-more') : null; }

  function urlSuivante() {
    var l = loader();
    if (!l) return '';
    var champ = l.querySelector('[data-next-url]');
    return champ && champ.value ? champ.value.trim() : '';
  }

  function resteDesPages() { return urlSuivante() !== ''; }

  function enStock() {
    return etat.grille.querySelectorAll(CARTE + ':not(.' + DIFFEREE + ')').length;
  }
  function enAttente() {
    return etat.grille.querySelectorAll('.' + ATTENTE).length;
  }
  function differees() {
    return etat.grille.querySelectorAll('.' + DIFFEREE).length;
  }

  function mettreDeCote() {
    var ko = etat.grille.querySelectorAll(RUPTURE);
    for (var i = 0; i < ko.length; i++) {
      ko[i].classList.remove(ATTENTE);
      if (!ko[i].classList.contains(DIFFEREE)) ko[i].classList.add(DIFFEREE);
    }
  }

  function ajusterFenetre() {
    var dispo = etat.grille.querySelectorAll(CARTE + ':not(.' + DIFFEREE + ')');
    for (var i = 0; i < dispo.length; i++) {
      if (i < etat.cible) dispo[i].classList.remove(ATTENTE);
      else dispo[i].classList.add(ATTENTE);
    }
  }

  function revelerALaFin() {
    var ko = etat.grille.querySelectorAll('.' + DIFFEREE);
    if (!ko.length) return;
    etat.vidage = true;
    /* Ruptures déjà toutes en fin de grille ? Alors on ne déplace rien. */
    var cartes = etat.grille.querySelectorAll(CARTE);
    var dejaEnFin = true, vuRupture = false;
    for (var j = 0; j < cartes.length; j++) {
      if (cartes[j].getAttribute('data-available') === 'false') vuRupture = true;
      else if (vuRupture) { dejaEnFin = false; break; }
    }
    var frag = document.createDocumentFragment();
    for (var i = 0; i < ko.length; i++) {
      ko[i].classList.remove(DIFFEREE);
      ko[i].classList.remove(ATTENTE);
      if (!dejaEnFin) frag.appendChild(ko[i]);
    }
    if (!dejaEnFin) etat.grille.appendChild(frag);
    /* Purge les mutations qu'on vient de provoquer : sinon l'observateur
       les reçoit après le retour de vidage à false et relance traiter() en boucle. */
    if (observateur) observateur.takeRecords();
    etat.vidage = false;
  }

  function majBouton() {
    var b = bouton();
    if (!b) return;
    if (enAttente() > 0 || differees() > 0 || resteDesPages()) b.classList.remove('hide');
    else b.classList.add('hide');
  }

  function demanderUnePageDePlus() {
    var l = loader();
    var b = bouton();
    if (!b) return;
    if (!loaderPret()) { setTimeout(demanderUnePageDePlus, 200); return; }
    var u = urlSuivante();
    if (!u) return;
    if (b.hasAttribute('disabled')) { setTimeout(demanderUnePageDePlus, 150); return; }
    etat.enCours = true;
    clearTimeout(etat.secours);
    etat.secours = setTimeout(function () { if (etat) etat.enCours = false; }, DELAI_SECOURS);
    var params = u.split('?')[1] || '';
    /* troisième argument à false : ne pas réécrire l'URL du navigateur */
    l.renderPage(params, null, false);
  }

  function traiter() {
    if (!etat || etat.vidage) return;

    var total = etat.grille.querySelectorAll(CARTE).length;
    if (etat.enCours && total > etat.compteAvant) {
      /* la page demandée est arrivée */
      etat.enCours = false;
      clearTimeout(etat.secours);
    }

    mettreDeCote();
    ajusterFenetre();

    if (etat.enCours) { majBouton(); return; }

    if (enStock() < etat.cible && resteDesPages() && etat.auto < MAX_AUTO) {
      if (!loaderPret()) {
        /* on ne consomme pas de créneau tant que pagination.js n'a pas pris la main */
        clearTimeout(etat.minuteur);
        etat.minuteur = setTimeout(traiter, 200);
        majBouton();
        return;
      }
      etat.auto += 1;
      etat.compteAvant = total;
      majBouton();
      demanderUnePageDePlus();
      return;
    }
    if (!resteDesPages() && enAttente() === 0) revelerALaFin();
    majBouton();
  }

  function estVoirPlus(noeud) {
    while (noeud && noeud !== document) {
      if (noeud.classList && noeud.classList.contains('js-load-more')) return true;
      noeud = noeud.parentNode;
    }
    return false;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!etat || !e.isTrusted || !estVoirPlus(e.target)) return;
      etat.cible += etat.taillePage;
      etat.auto = 0;
      ajusterFenetre();
      if (enStock() >= etat.cible || !resteDesPages()) {
        /* de quoi remplir sans aller chercher une page : on empêche
           le thème de lancer une requête (et, en dernière page, de
           construire une URL « ?undefined ») */
        e.preventDefault();
        e.stopPropagation();
        if (!resteDesPages() && enAttente() === 0) revelerALaFin();
        majBouton();
      }
    },
    true
  );

  function brancher() {
    var conteneur = document.querySelector(CONTENEUR);
    var grille = document.querySelector(GRILLE);
    if (!conteneur || !grille) return false;
    if (etat && etat.grille === grille) return true;

    var n = grille.querySelectorAll(CARTE).length || 18;
    /* Arrivée directe sur ?page=3 : pagination.js va préfixer les pages 1 et 2.
       L'objectif doit donc valoir trois pages, sinon on n'en afficherait qu'une. */
    var page = 1;
    try {
      page = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10) || 1;
    } catch (err) { page = 1; }
    etat = {
      grille: grille,
      taillePage: n,
      cible: n * page,
      auto: 0,
      vidage: false,
      minuteur: null,
      enCours: false,
      compteAvant: 0,
      secours: null
    };

    if (observateur) observateur.disconnect();
    observateur = new MutationObserver(function () {
      if (!etat || etat.vidage) return;
      if (document.querySelector(GRILLE) !== etat.grille) { brancher(); return; }
      clearTimeout(etat.minuteur);
      etat.minuteur = setTimeout(traiter, 60);
    });
    observateur.observe(conteneur, { childList: true, subtree: true });

    traiter();
    return true;
  }

  function demarrer() {
    style();
    if (brancher()) return;
    /* la grille peut arriver après nous : rendu de section, facettes */
    var essais = 0;
    var t = setInterval(function () {
      if (brancher() || ++essais > 40) clearInterval(t);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer, { once: true });
  } else {
    demarrer();
  }
})();